import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { DropdownItem, IconName } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { RateType } from '@mews-commander/data-access';
import { FormSelectField, LocalizedText } from '@mews/framework';
import { TooltippedIcon } from '@mews-commander/ui';
import { WithEnterpriseIds } from '../../../../../types';
import { getEntitiesExternalIdentifiersIntersection, getExternalIdentifiersGroups } from '../../../../../utilities';
import { useRateFormContext } from '../hooks/RateFormProvider';
import { BASE_RATE_KEY_FIELD_NAME } from './fieldNames';
import { WithFieldsConfig } from './types';
import { getFieldDisabledConfig } from './helpers';

export const RateBaseRateField = ({ enterpriseIds, fieldsConfig }: WithEnterpriseIds & WithFieldsConfig) => {
    const { rateResults, isFetching } = useRateFormContext();

    const rates = pipe(
        rateResults?.rates || [],
        array.filter((rate) => rate.type !== RateType.AvailabilityBlock),
        getExternalIdentifiersGroups,
        getEntitiesExternalIdentifiersIntersection
    );

    const isDisabled = isFetching || getFieldDisabledConfig(BASE_RATE_KEY_FIELD_NAME, fieldsConfig) || !rates.length;
    let disabledStateText = null;

    if (array.isEmpty(rates)) {
        disabledStateText =
            enterpriseIds.length > 1
                ? TextKey.BaseRateKeyFieldDisabledReasonPlural
                : TextKey.BaseRateKeyFieldDisabledReason;
    }

    return (
        <FormSelectField
            name={BASE_RATE_KEY_FIELD_NAME}
            helper={!isFetching && disabledStateText ? <LocalizedText textKey={disabledStateText} /> : null}
            captionIconWithTooltip={
                <TooltippedIcon size="small" value={IconName.Help} tooltip={TextKey.BaseRateKeyHelperText} />
            }
            label={<LocalizedText textKey={TextKey.BaseRateKey} />}
            disabled={isDisabled}
            loader={isFetching}
            required
            virtualized
        >
            {rates.map((rate) => (
                <DropdownItem key={rate} value={rate} label={rate} />
            ))}
        </FormSelectField>
    );
};
